import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { KundeKategorieLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';

interface KundeKategorieProps {
    disabled: boolean;
    value: string;
    onChange: (newValue: string) => void;
}

export const KundeKategorie: React.FC<KundeKategorieProps> = ({ value, disabled, onChange }) => {
    return (
        <>
            <Label>Kategorie</Label>
            <Select
                name="anrede"
                isDisabled={disabled}
                value={
                    value
                        ? {
                              value,
                              label: KundeKategorieLabel[value] || value,
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={Object.keys(KundeKategorieLabel).map((key) => ({
                    value: key,
                    label: KundeKategorieLabel[key],
                }))}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
            />
        </>
    );
};
